import React from 'react';
import PropTypes from 'prop-types';
import getHTMLElement from '../lib/setHtmlHelper';
import { Header } from 'marketing-components';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';

export default class Headercontainer extends React.Component {
  constructor(props) {
    super(props);
  }

  renderHeader() {
    const { isLoggedIn, isNewMppEnabled, header } = this.props;

    // IF new MPP remote config is enabled
    if (JSON.parse(isNewMppEnabled)) {
      // parse the header content as we stringified the content in controller level.
      const headerContent = JSON.parse(header);
      const { contentLoggedIn, contentLoggedOut, config } = headerContent;
      const props = {
        content: JSON.parse(isLoggedIn) ? contentLoggedIn : contentLoggedOut,
        config,
      };
      props.config.version = 'v4';
      return <Header {...props} />;
    }
    return getHTMLElement(header, { useHTML: true });
  }

  render() {
    const { country, locale, useGlobalNav } = this.props;

    if (JSON.parse(useGlobalNav)) {
      return <NavFragment type="header" />;
    }

    const fontChange =
      country === 'vn' && locale === 'vi_VN'
        ? 'vnFont'
        : country === 'jp' && locale === 'ja_JP'
        ? 'jpFont'
        : '';

    return <section className={fontChange}>{this.renderHeader()}</section>;
  }
}
Headercontainer.propTypes = {
  header: PropTypes.string,
  isLoggedIn: PropTypes.string,
  isNewMppEnabled: PropTypes.string,
  useGlobalNav: PropTypes.string,
};
